import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {ReactElement, useContext, useEffect, useState} from "react";
import {AuthContext, AUTHSTATES} from "./AuthProvider";
import {Box, CircularProgress} from "@mui/joy";
import {APIurl} from "./Utils";
import {Login} from "../pages/Login";
import {Account} from "../pages/Account";
import {PayWrapper} from "../pages/Pay";
import {Confirmation} from "../pages/Confirmation";
import {BillingDetails} from "../pages/BillingDetails";

export function Router() {

    const {authState, userCompany, userData, subscriptions} = useContext(AuthContext)
    return (
        <>
            {
                authState === AUTHSTATES.UNKNOWN ?
                    <Box sx={{display:"flex", justifyContent:"center", alignItems:"center", width:"100vw", height:"100vh"}}>
                        <CircularProgress />
                    </Box>
                    :
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={authState === AUTHSTATES.LOGGEDIN ? <Account /> : <Navigate to="/login" />}/>
                            <Route path="/login" element={authState === AUTHSTATES.LOGGEDIN ? <Navigate to="/" /> : <Login />} />
                            <Route path="/billing-details" element={authState === AUTHSTATES.LOGGEDIN ? <BillingDetails /> : <Navigate to="/login" />} />
                            <Route path="/pay" element={authState === AUTHSTATES.LOGGEDIN ? <PayWrapper /> : <Navigate to="/login" />} />
                            <Route path="/completion" element={authState === AUTHSTATES.LOGGEDIN ? <Confirmation /> : <Navigate to="/login" />} />
                        </Routes>
                    </BrowserRouter>
            }
        </>
    )
}